import React, { useState } from "react";
import apiFetch from "../helpers/requests";
import { useTranslation } from "react-i18next";

const ConfirmDeleteLicenseModal = ({
  setShowConfirmDeleteLicenseModal,
  licenseId,
  handleDeleteLicense,
}) => {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const deleteLicense = async (licenseId: string | null) => {
    try {
      const data = await apiFetch(`/deleteLicense`, {
        method: "POST",
        body: JSON.stringify({ licenseId }),
      });
      return data;
    } catch (error) {
      console.error("Error delete license:", error);
      throw new Error("An error occurred while delete license");
    }
  };

  const handleDeleteLicenseClick = async (licenseId: string | null) => {
    setIsLoading(true);
    try {
      await deleteLicense(licenseId);
      handleDeleteLicense(licenseId);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  return (
    <div className="confirmation-modal">
      <div className="modal-content">
        <div
          style={{ textAlign: "center", fontSize: "1.3em", marginTop: "2vh" }}
        >
          {t("Confirm_to_delete_license")}
        </div>
        <label style={{ lineHeight: "1", marginTop: "2vh" }}>
          {t("This_is_irreversible_action.")}
        </label>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "5vh",
            maxHeight: "1%",
          }}
        >
          <div className="userDataWrapper">{licenseId}</div>
        </div>
        <div className="button-container">
          <button
            type="button"
            className="buttonCancel btn btn-primary"
            disabled={isLoading}
            onClick={() => setShowConfirmDeleteLicenseModal(false)}
          >
            {t("Cancel")}
          </button>
          <button
            type="button"
            className="buttonAccept btn btn-primary"
            disabled={isLoading}
            onClick={() => handleDeleteLicenseClick(licenseId)}
          >
            {isLoading ? t("Loading...") : t("Delete")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteLicenseModal;
